export const CANNEDCOMMAND_DELETE_OPEN_MODAL = "CANNEDCOMMAND_DELETE_OPEN_MODAL";
export const CANNEDCOMMAND_DELETE_REQUEST = "CANNEDCOMMAND_DELETE_REQUEST";
export const CANNEDCOMMAND_DELETE_RESULT = "CANNEDCOMMAND_DELETE_RESULT";
